module.exports = __webpack_public_path__ + "static/media/test18_3.3e74a026.png";